import { useImperativeHandle, useRef } from 'react';
import type { Ref } from 'react';
import { useTranslation } from 'react-i18next';

import { NgButton, NgModal } from '@/ui';
import type { NgModalHandle } from '@/ui';

export type ConfirmOrRejectIncidentShareDialogHandle = {
  show: () => void;
};

export type ConfirmOrRejectIncidentShareDialogProps = {
  onResult: (confirmed: boolean) => void | Promise<void>;
  ref?: Ref<ConfirmOrRejectIncidentShareDialogHandle>;
};

export function ConfirmOrRejectIncidentShareDialog({ onResult, ref }: ConfirmOrRejectIncidentShareDialogProps) {
  const { t } = useTranslation();
  const modalRef = useRef<NgModalHandle>(null);

  useImperativeHandle(ref, () => ({
    show: () => {
      modalRef.current?.show();
    },
  }));

  const onConfirm = async () => {
    modalRef.current?.hide();
    await onResult(true);
  };

  const onReject = async () => {
    modalRef.current?.hide();
    await onResult(false);
  };

  return (
    <NgModal
      ref={modalRef}
      header={t('Incident_Collaboration_TimeoutDialog_Title')}
      disableClosingDialog
      bodyTemplate={<>{t('Incident_Collaboration_TimeoutDialog_Message')}</>}
      footerTemplate={
        <>
          <NgButton type="primary" text={t('Incident_Collaboration_ConfirmButton')} onClick={onConfirm} />
          <NgButton type="primary" text={t('Incident_Collaboration_RejectButton')} onClick={onReject} />
        </>
      }
    />
  );
}
